import "./_slider-team.scss";

document.addEventListener("DOMContentLoaded", function () {
  // Trova tutte le righe del team
  const rows = document.querySelectorAll(".row-team");

  rows.forEach((row) => {
    // Calcola la larghezza reale della row scrollWidth include tutto il contenuto scrollabile orizzontale
    const rowWidth = row.scrollWidth;

    // Imposta la variabile CSS --row-width a livello inline
    row.style.setProperty("--row-width", `${rowWidth}px`);

    // Debug
    // console.log(`Larghezza calcolata per row-team: ${rowWidth}px`);
  });
});
